import { create } from "zustand";

export interface TextAnnotationDialogResult {
    note: string;
    fontSize: number;
}

interface TextAnnotationDialogState {
    isOpen: boolean;
    _resolve: ((result: TextAnnotationDialogResult | null) => void) | null;

    showDialog: () => Promise<TextAnnotationDialogResult | null>;
    confirm: (result: TextAnnotationDialogResult) => void;
    cancel: () => void;
}

export const useTextAnnotationDialogStore = create<TextAnnotationDialogState>()((set, get) => ({
    isOpen: false,
    _resolve: null,

    showDialog: () =>
        new Promise((resolve) => {
            set({ isOpen: true, _resolve: resolve });
        }),

    confirm: (result) => {
        get()._resolve?.(result);
        set({ isOpen: false, _resolve: null });
    },

    cancel: () => {
        get()._resolve?.(null);
        set({ isOpen: false, _resolve: null });
    },
}));
